import { useEffect } from 'react';

function useCleanupEffectBeforeUnloading(cleanupCallback, deps) {
  /*
  A custom hook to encapsulate clean up logic that should also run before the page unloads.
  This ensures the cleanupCallback will still run if the page is closed or reloaded.
  @param {Function} cleanupCallback - A function that will be called before the page unloads.
  @param {Array} deps - An array of dependencies that will be passed to the cleanupCallback.
  */
  // This useEffect sets a 'beforeunload' event listener on component mount
  // and removes it on component unmount. This ensures that the cleanupCallback
  // will be called when the user navigates away from the page, even if the
  // component is not unmounted yet (for instance, if they close the tab/window).
  useEffect(() => {
    window.addEventListener('beforeunload', () => cleanupCallback());
    return () => {
      window.removeEventListener('beforeunload', () => cleanupCallback());
    };
  }, []);

  // This useEffect will run the cleanupCallback during the normal cleanup phase
  // of the component's lifecycle. The cleanupCallback will be set any time one
  // of the deps changes, and called any time the component unmounts/updates.
  useEffect(() => {
    return () => {
      cleanupCallback();
    };
  }, deps);
}

export default useCleanupEffectBeforeUnloading;
